export default "__VITE_ASSET__CyWXlNxR__"